"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIdNode = createIdNode;
var _rdflib = require("rdflib");
let lastIssuedTimestamp = 0;
function createIdNode(doc) {
  const now = Date.now();
  const timestampId = now > lastIssuedTimestamp ? now : lastIssuedTimestamp + 1;
  lastIssuedTimestamp = timestampId;
  return (0, _rdflib.sym)(`${doc.uri}#id${timestampId}`);
}